<template>
  <div class="detail-container">
    <h1>測定機器情報詳細</h1>
    <div v-if="device">
      <table class="table table-bordered">
        <tr>
          <th>測定機器名</th>
          <td>{{ device.device_nm }}</td>
        </tr>
        <tr>
          <th>製造者</th>
          <td>{{ device.manufacuturer }}</td>
        </tr>
        <tr>
          <th>型式</th>
          <td>{{ device.model_nm }}</td>
        </tr>
        <tr>
          <th>製造番号</th>
          <td>{{ device.serial_no }}</td>
        </tr>
        <tr>
          <th>仕様</th>
          <td>{{ device.specification }}</td>
        </tr>
        <tr>
          <th>価格</th>
          <td>{{ device.price }}</td>
        </tr>
        <tr>
          <th>最終更新日</th>
          <td>{{ device.last_upd_dt }}</td>
        </tr>
      </table>

      <div class="btn-area">
        <router-link :to="{ name: 'DeviceList', params: { id: device.id }}"> <!-- 顧客情報編集ページへのリンク -->
          <button type="button" class="btn btn-primary">一覧へ</button>
        </router-link>

        <router-link v-if="isAdmin" :to="{ name: 'DeviceEdit', params: { id: device.id }}"> <!-- 顧客情報編集ページへのリンク -->
          <button type="button" class="btn btn-success mx-2">編集</button>
        </router-link>
      </div>
    </div>
    <!-- その他の詳細情報 -->
    <div v-else>
      測定機器情報情報を読み込み中...
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getDevice } from '@/api/axios';
import { currentRoleFromStoreOrLocalStorage, isAdminRole } from '@/utils/roleAuthorization';

export default {
  setup() {
    const title = ref('測定機器情報詳細');
    const store = useStore();

    watchEffect(() => {
      document.title = title.value;
    });

    const isAdmin = computed(() => isAdminRole(currentRoleFromStoreOrLocalStorage(store.state.userRole)));
    const device = ref({});
    const route = useRoute();
    const deviceId = route.params.id;

    const fetchDevice = async () => {
      const response = await getDevice(deviceId);
      device.value = response.data;
    };

    onMounted(fetchDevice);

    return {
      title,
      isAdmin,
      device
    };
  }
};
</script>

<style scoped>
.detail-container {
  width: 70%;
  padding: 20px;
  margin: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.detail-item {
  margin-bottom: 10px;
}

table th {
  background: #2c3e50;
  color: #fff;
}

table th,
table td{
  padding: 8px;
}

.btn-area{
  text-align: center;
}
</style>
